// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpdesksection-inline-1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.helpdesksection-inline-2 {
  font-size: 13px;
  color: #64748b;
}

.helpdesksection-inline-3 {
  font-size: 11px;
  padding: 6px 12px;
  background: #4f46e5;
  color: #fff;
}

.helpdesksection-inline-4 {
  padding: 16px;
  margin-bottom: 12px;
}

.helpdesksection-inline-5 {
  margin-bottom: 8px;
}

.helpdesksection-inline-6 {
  font-size: 11px;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.helpdesksection-inline-7 {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 12px;
}

.helpdesksection-inline-8 {
  margin-bottom: 8px;
}

.helpdesksection-inline-9 {
  font-size: 11px;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.helpdesksection-inline-10 {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 12px;
  box-sizing: border-box;
}

.helpdesksection-inline-11 {
  margin-bottom: 8px;
}

.helpdesksection-inline-12 {
  font-size: 11px;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.helpdesksection-inline-13 {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 12px;
  box-sizing: border-box;
}

.helpdesksection-inline-14 {
  margin-bottom: 8px;
}

.helpdesksection-inline-15 {
  font-size: 11px;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.helpdesksection-inline-16 {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 12px;
}

.helpdesksection-inline-17 {
  background: #4f46e5;
  color: #fff;
  padding: 8px 16px;
  font-size: 12px;
}

.helpdesksection-inline-18 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
}

.helpdesksection-inline-19 {
  padding: 20px;
  text-align: center;
  color: #94a3b8;
}

.helpdesksection-inline-20 {
  padding: 14px;
  margin-bottom: 8px;
}

.helpdesksection-inline-21 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.helpdesksection-inline-22 {
  font-weight: 600;
  font-size: 13px;
}

.helpdesksection-inline-23 {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}

.helpdesksection-inline-24 {
  font-size: 12px;
  color: #475569;
  margin-top: 6px;
  line-height: 1.5;
}

.helpdesksection-inline-25 {
  margin-top: 8px;
  padding: 10px;
  background: #eff6ff;
  border-radius: 8px;
  font-size: 12px;
  border-left: 3px solid #2563eb;
}

.helpdesksection-inline-26 {
  color: #2563eb;
}

.helpdesksection-inline-27 {
  text-align: right;
  flex-shrink: 0;
}

.helpdesksection-inline-28 {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 4px;
}

.helpdesksection-dyn-1 {
  font-size: 10px;
  font-weight: 600;
  color: var(--helpdesksection-1-color);
  background: var(--helpdesksection-1-background);
  padding: 3px 8px;
  border-radius: 99px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/HelpDeskSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,+CAA+C;EAC/C,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".helpdesksection-inline-1 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.helpdesksection-inline-2 {\n  font-size: 13px;\n  color: #64748b;\n}\n\n.helpdesksection-inline-3 {\n  font-size: 11px;\n  padding: 6px 12px;\n  background: #4f46e5;\n  color: #fff;\n}\n\n.helpdesksection-inline-4 {\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.helpdesksection-inline-5 {\n  margin-bottom: 8px;\n}\n\n.helpdesksection-inline-6 {\n  font-size: 11px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.helpdesksection-inline-7 {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  font-size: 12px;\n}\n\n.helpdesksection-inline-8 {\n  margin-bottom: 8px;\n}\n\n.helpdesksection-inline-9 {\n  font-size: 11px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.helpdesksection-inline-10 {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  font-size: 12px;\n  box-sizing: border-box;\n}\n\n.helpdesksection-inline-11 {\n  margin-bottom: 8px;\n}\n\n.helpdesksection-inline-12 {\n  font-size: 11px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.helpdesksection-inline-13 {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  font-size: 12px;\n  box-sizing: border-box;\n}\n\n.helpdesksection-inline-14 {\n  margin-bottom: 8px;\n}\n\n.helpdesksection-inline-15 {\n  font-size: 11px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.helpdesksection-inline-16 {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  font-size: 12px;\n}\n\n.helpdesksection-inline-17 {\n  background: #4f46e5;\n  color: #fff;\n  padding: 8px 16px;\n  font-size: 12px;\n}\n\n.helpdesksection-inline-18 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n}\n\n.helpdesksection-inline-19 {\n  padding: 20px;\n  text-align: center;\n  color: #94a3b8;\n}\n\n.helpdesksection-inline-20 {\n  padding: 14px;\n  margin-bottom: 8px;\n}\n\n.helpdesksection-inline-21 {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.helpdesksection-inline-22 {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.helpdesksection-inline-23 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.helpdesksection-inline-24 {\n  font-size: 12px;\n  color: #475569;\n  margin-top: 6px;\n  line-height: 1.5;\n}\n\n.helpdesksection-inline-25 {\n  margin-top: 8px;\n  padding: 10px;\n  background: #eff6ff;\n  border-radius: 8px;\n  font-size: 12px;\n  border-left: 3px solid #2563eb;\n}\n\n.helpdesksection-inline-26 {\n  color: #2563eb;\n}\n\n.helpdesksection-inline-27 {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.helpdesksection-inline-28 {\n  font-size: 10px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n\n.helpdesksection-dyn-1 {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--helpdesksection-1-color);\n  background: var(--helpdesksection-1-background);\n  padding: 3px 8px;\n  border-radius: 99px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
